import { Checkbox } from '@monash/portal-react';

const StatusFilters = ({ options, value: valueProp, onChange }) => {
  const handleCheck = (optionValue, e) => {
    const checked = e.target.checked;
    const newValue = checked
      ? [...valueProp, optionValue]
      : valueProp.filter((v) => v !== optionValue);
    onChange(newValue);
  };

  return options.map((option) => {
    const optValue = option.value;
    const isChecked = valueProp?.includes(optValue);

    return (
      <Checkbox
        key={optValue}
        on={isChecked}
        onChange={(e) => handleCheck(optValue, e)}
        text={option.text}
      />
    );
  });
};

export default StatusFilters;
